<template>
    <a :class="buttonClass" @click.prevent="call" v-if="!processing" v-html="buttonContent"></a>
    <span :class="cssClassProcessing" v-else>
        <i class="fas fa-spinner fa-spin"></i>{{ computedLabelProcessing }}
    </span>
</template>
<script>
    import Processing from '../../mixins/Processing';

    export default {
        mixins: [Processing],
        props: {
            route: {
                type: String,
                required: true,
            },
            cssClassOn: {
                type: String,
                required: false,
            },
            cssClassOff: {
                type: String,
                required: false,
            },
            cssClassProcessing: {
                type: String,
                required: false,
            },
            iconOn: {
                type: String,
                required: false,
            },
            iconOff: {
                type: String,
                required: false,
            },
            labelOn: {
                type: String,
                required: false,
            },
            labelOff: {
                type: String,
                required: false,
            },
            labelProcessing: {
                type: String,
                required: false,
            },
            isOn: {
                type: Boolean,
                required: true,
            },
            event: {
                type: String,
                required: false,
            },
            enableEvent: {
                type: String,
                required: false,
            },
            disableEvent: {
                type: String,
                required: false,
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                on: this.isOn,
                isDisabled: this.disabled,
            };
        },
        mounted() {
            if (this.enableEvent) {
                EventHandler.listen(this.enableEvent, this.enable);
            }
            if (this.disableEvent) {
                EventHandler.listen(this.disableEvent, this.disable);
            }
        },
        computed: {
            buttonClass() {
                let css = [];
                if (this.isDisabled) {
                    css.push('disabled');
                }
                css.push(this.on ? this.cssClassOn : this.cssClassOff);
                return css.join(' ');
            },
            computedLabelOn() {
                return this.labelOn ? ' ' + this.labelOn : '';
            },
            computedLabelOff() {
                return this.labelOff ? ' ' + this.labelOff : '';
            },
            label() {
                return this.on ? this.computedLabelOn : this.computedLabelOff;
            },
            computedLabelProcessing() {
                return this.labelProcessing ? ' ' + this.labelProcessing : '';
            },
            buttonContentOn() {
                let button = '';
                if (this.iconOn) {
                    button += '<i class="' + this.iconOn + '"></i>';
                }
                return button + this.label;
            },
            buttonContentOff() {
                let button = '';
                if (this.iconOff) {
                    button += '<i class="' + this.iconOff + '"></i>';
                }
                return button + this.label;
            },
            buttonContent() {
                return this.on ? this.buttonContentOn : this.buttonContentOff;
            },
        },
        methods: {
            enable() {
                this.isDisabled = false;
            },
            disable() {
                this.isDisabled = true;
            },
            call() {
                if (this.processing || this.isDisabled) {
                    return;
                }
                this.startCall();
                window.axios.get(this.route).then(this.success).catch(this.failure);
            },
            success(response) {
                if (response.data.redirect) {
                    window.location.href = response.data.redirect;
                    return;
                }
                this.endCall();
                this.on = response.data.is_on;
                if (this.event) {
                    window.EventHandler.fire(
                        this.event,
                        {
                            id: response.data.id,
                            is_on: response.data.is_on,
                        },
                    );
                }
            },
            failure(error) {
                this.endCall();
                throw new Error(error);
            },
        },
    };
</script>
